var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date--separator",class:_vm.$dm('text-secondary', 'dark:text-secondary-dark')},[_vm._v("\n  "+_vm._s(_vm.formattedDate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }